
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './authentication/auth-guard.service';
import { LoginComponent } from './authentication/login/login.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { HomeComponent } from './components/forms/home/home.component';
import { LoginErrorPageComponent } from './authentication/login-error-page/login-error-page.component';

const appRoutes: Routes = [
    //{ path: 'installpage', component: InstallComponent },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'loginerrorpage', component: LoginErrorPageComponent },
    { path: '', component: HomeComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {   useHash: false,
                //enableTracing: true // <-- debugging purposes only
            } 
        )
    ],
    exports: [
        RouterModule
    ],
    providers: [
    ]
})

export class AppRoutingModule { }